import { sql } from 'drizzle-orm';
import { pgTable, uuid, timestamp, varchar, index } from 'drizzle-orm/pg-core';
import { users } from './users';
import { DEFAULT_TENANT_USER_ID } from '../constants';
const schema = {
  id: uuid('id').defaultRandom().primaryKey(),
  external_id: uuid('external_id').defaultRandom().notNull().unique(),
  name: varchar('name', { length: 128 }).notNull(),
  user_id: uuid('user_id')
    .notNull()
    .references(() => users.id)
    .default(DEFAULT_TENANT_USER_ID),
  date_created: timestamp('date_created', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
  date_modified: timestamp('date_modified', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
}

/**
 * @ignore
 **/
export const tenants = pgTable(
  'Tenants', 
  schema,
  (table) => [
    index('tenant_external_id_idx').on(table.external_id),
    index('tenant_user_id_idx').on(table.user_id),
    index('tenant_name_idx').on(table.name),
  ]
); 